import { post } from '@/utilities/onwardClient';
import { EXCEPTIONS_EXPORT_CSV } from '@/constants/apiRoutes';

export const exportCsv = async ({ query }) => {
    return post(EXCEPTIONS_EXPORT_CSV, {
        type: 'EXCEPTIONS',
        query,
    });
};
